import { NgModule } from '@angular/core';
import { CommonModule, } from '@angular/common';
import { BrowserModule  } from '@angular/platform-browser';
import { Routes, RouterModule } from '@angular/router';
import {AuthGuardService as AuthGuard} from '../app/modules/auth/_services/auth-guard.service'

import { AdminLayoutComponent } from './layouts/admin-layout/admin-layout.component';

export const routes: Routes =[
  {
    path : '', redirectTo: '/auth', pathMatch : 'full'
  },
  {
    path : 'auth', loadChildren : () => import('./modules/auth/auth.module').then(m => m.AuthModule)
  },
  {
    path : 'payments', loadChildren : () => import('./modules/payment/payment.module').then(m => m.PaymentModule)
  },

  {
    path: '',
    component: AdminLayoutComponent,
    children: [
        {
          path: 'app',
          canActivate: [AuthGuard],
          loadChildren: () => import('./layouts/admin-layout/admin-layout.module').then(m => m.AdminLayoutModule)
        }
    ]
  },
  // {
  //   path: '**',
  //   redirectTo: 'auth'
  // }
];

@NgModule({
  imports: [
    CommonModule,
    BrowserModule,
    RouterModule.forRoot(routes,{
    useHash: true,
    relativeLinkResolution: 'legacy'
})
  ],
  exports: [
  ],
})
export class AppRoutingModule { }
